import axios from "axios";
import moment from "moment";
import React, { useEffect, useState, useReducer } from "react";

import { Modal } from "../../components/Modal/Modal.component";

import Aside from "../../components/Aside/Aside";
import { TariffProfile, ProfileTariff } from "../../types";

import Notification from "../../components/Alert/notification";
import { Navigate } from "react-router-dom";

interface TariffsProps { }

const TariffsPage: React.FC<TariffsProps> = () => {
  const [tariff, setTariff] = useState<ProfileTariff[]>();
  const [tariffDescription, setTariffDescription] = useState("");
  const [profile, setProfile] = useState<TariffProfile>();
  const [nextTariffID, setNextTariff] = useState("");
  const [nextTariffDescription, setNextTariffDescription] = useState("");
  const [notification, setNotification] = useState(false);

  const [exporessNextID, setExpressNextID] = useState(0)


  const [isOpenButtonChangeTariff, setIsOpenButtonChangeTariff] = useState(true)

  // Checked money tariff
  const [endCost, setEndCost] = React.useState(0)

  const [isModalOpen, setModalState] = React.useState(false);
  const toggleModal = () => setModalState(!isModalOpen);


  const startOfMonth = moment().startOf("month").format("D MMM YYYY");
  const nextMonth = moment()
    .add("month", 1)
    .startOf("month")
    .format("D MMM YYYY");
  //const endOfMonth = moment().endOf("month").format("YYYY-MM-DD hh:mm");

  const nextTariffName = async ({
    profile,
    tariff,
  }: {
    profile: any;
    tariff: any;
  }) => {
    const elemID = await axios
      .post("v1/tariffs/shownexttariff", {
        user_id: `${profile?.id}`,
        account_id: `${profile?.basicAccount}`,
      })
      .then((response) => {
        tariff?.forEach((element: any) => {
          if (element.id === response.data.next_tariff) {
            setNextTariff(element.name);
            setNextTariffDescription(element.comments);
          }
        });
      });
    return elemID;
  };

  useEffect(() => {
    Promise.all([axios.get("v1/profile/info"), axios.get("v1/tariffs/all")])
      .then(([profile, tariff]) => {
        tariff.data.tariffs.map((el: any) => {
          if (el.name === profile.data.tariffName) {
            setTariffDescription(el.comments);
          }
        });

        setProfile(profile.data);
        setTariff(tariff.data.tariffs);
        return { profile: profile.data, tariff: tariff.data.tariffs };
      })
      .then(nextTariffName)
      .then((res) => console.log(res))
      .catch((err) => console.log(err));
  }, []);

  if (profile?.tariffName === "Стартовый Ямал") return <Navigate to="/inet/activate" />;

  const ChangeTariff = async (id: any) => {
    try {
      await axios
        .post("v1/tariffs/change", {
          tariff_link_id: profile?.tariffLinkID,
          account_id: profile?.basicAccount,
          next_tariff_id: id,
        })
        .then((res) => {
          if (res.data.message === "OK") {
            setNotification(true);
            setTimeout(() => {
              setNotification(false);
            }, 5000);
          }
        });
    } catch (err) {
      console.log(err);
    }
  };


  const checkedMoneyForChangeTariff = (cost: number, id: number) => {
    const summa = cost - 200 - profile!.balance;
    setEndCost(summa)
    setExpressNextID(id)
    //console.log("Money Cost:", summa);
    setModalState(true)
  }

  const ExpressChangeTariff = async () => {
    try {
      await axios
        .post("/v1/tariffs/expressChange", {
          account_id: profile?.basicAccount,
          user_id: profile?.id,
          tariff_link_id: profile?.tariffLinkID,
          first_tariff_id: profile?.tariffID,
          second_tariff_id: exporessNextID,
        }).then(res => {
          if (res.data.tariffLinkID === profile?.tariffLinkID) {
            setModalState(false);
            window.location.reload();
          }
        })
    } catch (e) { console.log("Error:", e) }
    console.log("TriffLinkID:", profile?.tariffLinkID)
    console.log("FirstTariffID", profile?.tariffID)
    console.log("SecondTariffID", exporessNextID)
    console.log("AccountID:", profile?.basicAccount)
    console.log("UserID:", profile?.id)
  }

  const handleChangeCheckedButton = () => {
    setIsOpenButtonChangeTariff(!isOpenButtonChangeTariff);
  };


  return (

    <div
      data-v-dde546dc=""
      className="el-container app__container app__content"
    >
      <Modal
        title={"Активировать тариф"}
        isOpen={isModalOpen}
        onClose={toggleModal}
      >
        <h2>Уважаемый абонент.</h2>
        <div style={{ "textAlign": "justify" }}>
          Вы хотите активировать новый тарифный план прямо сейчас.
          Данная услуга платная. Стоимость услуги составляет: <b style={{ "fontWeight": "600" }}>200</b> рублей.
        </div>
        <div style={{ "textAlign": "justify" }}>
          <span style={{ "color": "red", "textAlign": "center" }}>Обращаем ваше внимание.</span><br />
          Вам необходимо будет заплатить: (стоимость тарифа + <b style={{ "fontWeight": "600" }}>200</b> рублей).

        </div>
        <div style={{ "textAlign": "justify", "color": "red" }}>
          Абонентская плата спишется в полном объеме.
          Никаких перерасчетов производиться не будет!

        </div>
        <div style={{ "textAlign": "justify", "marginTop": "20px" }}>
          <label>
            <input
              checked={isOpenButtonChangeTariff}
              onChange={handleChangeCheckedButton}
              type="checkbox"
              defaultChecked
            />
            <span style={{ "marginLeft": "20px", "color": "red" }}>«Прочитал, ознакомился, подтверждаю»</span>
          </label>

        </div>

        <div style={{ "marginTop": "20px" }}>
          <div style={{ "marginBottom": "20px" }}>
            <span style={{ "color": "#1a9727", "textAlign": "left", "fontWeight": "500" }} >Ваш баланс: {profile?.balance} </span> <br />
            <span style={{ "color": "#1a9727", "textAlign": "left", "fontWeight": "500" }} >Cумма к оплате: {endCost} </span> <br />
          </div>

          {isOpenButtonChangeTariff ?
            <button
              data-v-42bf1688=""
              type="submit"
              className="el-button el-button--success el-button--small "
              onClick={() => ExpressChangeTariff()}
            >
              <span>
                <small data-v-42bf1688="">Сменить</small>
              </span>
            </button>
            : null}

        </div>
      </Modal>
      <Aside />

      <div data-v-dde546dc="" className="el-main">
        <div data-v-dde546dc="" className="change-tariff">
          <h1>Смена тарифа</h1>
          <div className="gutters cards mt-3 mb-3 el-row el-row--flex">
            <div className="el-col el-col-24 el-col-sm-12">
              <div className="el-card card--warning text-thin is-always-shadow">
                <div className="el-card__header">
                  <div>
                    <small>Текущий тарифный план</small>
                    <h3 className="card-title mt-1">{profile?.tariffName}</h3>
                    <p>{tariffDescription}</p>
                  </div>
                </div>
                <div className="el-card__body">
                  <small>действует с {startOfMonth} г. </small>
                </div>
              </div>
            </div>
            <div className="el-col el-col-24 el-col-sm-12">
              <div className="el-card card--success text-thin is-always-shadow">
                <div className="el-card__header">
                  <div>
                    <small>Следующий тарифный план</small>
                    <h3 className="card-title mt-1">{nextTariffID}</h3>
                    <p>{nextTariffDescription}</p>
                  </div>
                </div>
                <div className="el-card__body">
                  <small>начнёт действовать с {nextMonth} г.</small>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div>
              <div className="mt-4">
                <div className="el-table table el-table--fit el-table--enable-row-hover el-table--enable-row-transition">
                  <div className="el-table__header-wrapper">
                    {tariff?.reverse().map((el) => (
                      <>

                        <div
                          key={el.id}
                          className="el-card mt-4 card--success is-always-shadow"
                        >
                          <div className="el-card__header">
                            <div>
                              <i
                                aria-hidden="true"
                                className="fa fa-cubes card__icon"
                                style={{ fontSize: 80, top: 5 }}
                              ></i>
                              <div className="flex justify-between">
                                <h3>{el.name}</h3>
                                <h3
                                  className="text-success"
                                  style={{ fontWeight: 400 }}
                                >
                                  {el.cost} ₽
                                </h3>
                              </div>

                              <p className="text-thin">{el.comments}</p>
                            </div>
                          </div>
                          <div className="el-card__body" style={{ "display": "flex" }}>
                            <div>
                              <button
                                data-v-42bf1688=""
                                type="submit"
                                className="el-button el-button--success el-button--small "
                                onClick={() => ChangeTariff(el.id)}
                              >
                                <span>
                                  <small data-v-42bf1688="">Сменить</small>
                                </span>
                              </button>
                            </div>
                            <div style={{ "display": "flex", "marginLeft": "20px" }}>
                              <button
                                data-v-42bf1688=""
                                type="submit"
                                className="el-button el-button--danger el-button--small "
                                onClick={() => checkedMoneyForChangeTariff(el.cost, el.id)}
                              >
                                <span>
                                  <small data-v-42bf1688="">Активировать сейчас</small>
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </>


                    ))}
                  </div>
                  <div className="el-table__body-wrapper is-scrolling-none"></div>
                  <div
                    className="el-table__column-resize-proxy"
                    style={{ display: "none" }}
                  ></div>
                </div>
              </div>

              <div className="el-dialog__wrapper" style={{ display: "none" }}>
                <div
                  role="dialog"
                  aria-modal="true"
                  aria-label="Изменить тарифный план?"
                  className="el-dialog"
                  style={{ marginTop: "15vh" }}
                >
                  <div className="el-dialog__header">
                    <span className="el-dialog__title">
                      Изменить тарифный план?
                    </span>
                    <button
                      type="button"
                      aria-label="Close"
                      className="el-dialog__headerbtn"
                    >
                      <i className="el-dialog__close el-icon el-icon-close"></i>
                    </button>
                  </div>
                  <div className="el-dialog__footer">
                    <span className="dialog-footer">
                      <button
                        type="button"
                        className="el-button el-button--default el-button--small"
                      >
                        <span>Отмена</span>
                      </button>
                      <button
                        type="button"
                        className="el-button el-button--success el-button--small"
                      >
                        <span>Изменить</span>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="el-loading-mask" style={{ display: "none" }}>
              <div className="el-loading-spinner">
                <svg viewBox="25 25 50 50" className="circular">
                  <circle
                    cx="50"
                    cy="50"
                    r="20"
                    fill="none"
                    className="path"
                  ></circle>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      {notification ? (
        <Notification message={"Тарифный план успешно изменен"} />
      ) : null}
    </div>
  );
};

export default TariffsPage;
